<template>
  <div class="input-group">
    <v-select
      v-model="selectedCurrency"
      :options="currencyOptions"
      :placeholder="selectedCurrency"
      @input="onCurrencyChange"
      :clearable="false"
      class="currency-select">
    </v-select>
    <input 
      type="text" 
      class="form-control" 
      :placeholder="placeholderText"
      v-model="displayValue"
      @input="onInput"
      @blur="onBlur"
      :disabled="disabled">
  </div>
</template>

<script>
export default {
  name: 'CurrencyInput',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    currency: {
      type: String,
      default: 'IDR'
    },
    placeholder: {
      type: String,
      default: '1000000'
    },
    currencyOptions: {
      type: Array,
      default: () => ['IDR', 'USD']
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedCurrency: this.currency,
      displayValue: ''
    }
  },
  computed: {
    placeholderText() {
      const symbol = this.selectedCurrency === 'USD' ? '$' : 'Rp';
      const formatted = this.formatNumber(this.placeholder);
      return `${symbol} ${formatted}`;
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.displayValue = this.formatNumber(newVal);
        } else {
          this.displayValue = '';
        }
      }
    },
    currency: {
      immediate: true,
      handler(newVal) {
        this.selectedCurrency = newVal;
      }
    }
  },
  methods: {
    formatNumber(value) {
      if (!value) return '';
      const num = value.toString().replace(/\D/g, '');
      return num.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },

    parseNumber(value) {
      if (!value) return '';
      return value.replace(/\D/g, '');
    },

    formatCurrency(value, currency) {
      if (!value) return '';
      const symbol = currency === 'USD' ? '$' : 'Rp';
      const formatted = this.formatNumber(value);
      return `${symbol} ${formatted}`;
    },

    onInput(event) {
      const value = event.target.value;
      const numbers = this.parseNumber(value);
      this.displayValue = this.formatNumber(numbers);
 
      this.$emit('input', numbers);
    },

    onBlur() {
      if (this.value) {
        this.displayValue = this.formatCurrency(this.value, this.selectedCurrency);
      }
    },

    onCurrencyChange(newCurrency) {
      this.selectedCurrency = newCurrency;
      this.$emit('update:currency', newCurrency);

      if (this.value) {
        this.displayValue = this.formatCurrency(this.value, this.selectedCurrency);
      }
    }
  }
}
</script>

<style scoped>
.input-group .currency-select {
  width: 100px;
  flex: 0 0 100px;
}

::v-deep .input-group .currency-select .vs__dropdown-toggle {
  border-radius: 0.375rem 0 0 0.375rem;
  border-right: 0;
}

.input-group .form-control {
  border-radius: 0 0.375rem 0.375rem 0;
}

.form-control:focus {
  border-color: #e63757;
  box-shadow: 0 0 0 0.2rem rgba(230, 55, 87, 0.25);
}
</style>
